import { render, staticRenderFns } from "./MineFAQ.vue?vue&type=template&id=7cee96b2&scoped=true&"
import script from "./MineFAQ.vue?vue&type=script&lang=js&"
export * from "./MineFAQ.vue?vue&type=script&lang=js&"
import style0 from "./MineFAQ.vue?vue&type=style&index=0&id=7cee96b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cee96b2",
  null
  
)

export default component.exports